import { executeRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const getReqBody = (req: any, index: number, filename: string) => {
  return {
    IT_DMSCONTENT: [
      {
        KTOKD: '',
        DMS_SRNO: '' + index + 1,
        KUNNR: '',
        FILENAME: filename,
        FILE_EXTENSION: '',
        CHAR_VALUE: 'GST',
        DOC_NUM: '',
        VALID_FRM: '',
        VALID_TO: '',
        CONTENT: '',
      },
    ],
    IT_GENERAL: [
      {
        ANRED: 'Company',
        NAME1: req?.EntityName ?? '',
        NAME2: req?.AddressLine1 ?? '',
        NAME3: req?.AddressLine2 ?? '',
        ORT01: req?.City ?? '',
        REGIO: req?.StateCode ?? '',
        PSTLZ: req?.Pincode ?? '',
        LAND1: 'IN',
        SPRAS: 'English',
        STCD3: req?.GSTNumber ?? '',
        SOURCE_APP: 'MASCUST',
        SOURCE_ID: req?.EntityID ?? '',
        J_1IPANNO: req?.PANNumber ?? '',
        ZZGSTNO: req?.GSTNumber ?? '',
        KUNNR: '',
        SORTL: '',
        COUNC: '',
        CITYC: '',
        TELF1: '',
        TELF2: '',
        EMAIL: '',
        AUFSD: '',
        BAHNE: '',
        BEGRU: '',
        FAKSD: '',
        LIFSD: '',
        SPERR: '',
        CASSD: '',
        ZZGSTVALIDFROM: req?.GSTNumber ? '2017-07-01' : '',
        ZZGSTVALIDTO: req?.GSTNumber ? '9999-12-31' : '',
        ZZSTATUS: req?.GSTNumber ? '1' : 'F',
        ZZSTATUSFROM: '2017-07-01',
        ZZSTATUSTO: '9999-12-31',
        ZZGSTTYP: '',
        ZTERM: '',
        NAME4: '',
        STRAS: '',
        VKBUR: '6002',
        KTGRD: 'DO',
        ZZGSTIND: req?.GSTNumber ? 'Y' : 'N',
      },
    ],
  }
}
export const createCustomer = (tokens: any, req: any, index: number, filename: string, gwTokens: any) => {
  const request: any = {
    apiPath: APIEndPoints.sapCreateCustomer,
    method: 'POST',
    headers: {
      ...sitConfig(gwTokens).headers,
      session: tokens?.session ?? '',
      'x-csrf-token': tokens.csrfToken ?? '',
    },
    body: getReqBody(req, index, filename),
  }
  return executeRequest(request).then((data) => {
    return data
  })
}
